import {Box, Button, IconButton} from "@mui/material";
import './styles/task.scss'
import SearchIcon from '@mui/icons-material/Search';
import Checkbox from '@mui/material/Checkbox';
import Handle from "./handle";
import {
    CommandType,
    ConversionType,
    ExtraProps,
    FetchImagesSubTaskProcess,
    FetchImagesTaskProcess,
    TaskStatusType
} from "../../types/taskFlow.types";
import {useTaskFlow} from "../../context/TaskFlowContext";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import {useEffect, useState} from "react";
import {TLAsset} from "@tldraw/tlschema";
import {AssetRecordType} from "@tldraw/tldraw";
import PaintSwiper from "../swiper";
import { useWaterfallLayout } from '../../hooks/useWaterfallLayout';
import TaskTool from "../task_tool/confirm";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentTaskFrameIds} from "../../store/drawSlice";
import {RootState} from "../../store";
import {FrameShapeProps} from "../../types/draw.types";
import {Constant} from "../../types/constant";
import { useTranslation } from 'react-i18next'

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

interface LabelsProps {
    taskResponse?: FetchImagesTaskProcess,
    handleClickOpen: ()=>void,
    singleGenerate?: boolean,
    handleSetDialogInfo?: (info: FetchImagesSubTaskProcess) => void,
    taskId?: number,
    status: TaskStatusType
    extra?: ExtraProps,
    triggerCmd: CommandType
}

export default function Images (props: LabelsProps) {
    const { handleClickOpen , singleGenerate, extra , handleSetDialogInfo, triggerCmd, status, taskResponse, taskId} = props;
    const {updateStatus, conversionValue, changeTaskProcess, editor} = useTaskFlow()
    const [checkedImg, setCheckedImg] = useState<number[]>([])
    const { createWaterfallLayout } = useWaterfallLayout(editor);
    const currentTaskFrameIds = useSelector((state: RootState) => state.draw.currentTaskFrameIds);

    const changeProcessRes = (index?: number, isCheck?: boolean) => {
        const data = isCheck ? [...checkedImg, index as number] : checkedImg.filter((v) => v !== index)
        setCheckedImg(data)
        taskId && changeTaskProcess(taskId, {extra: { checkedImgs:data}})
    }

    const { t } = useTranslation()

    const temporary_url = process.env.REACT_APP_PROXY_TARGET ?? ''

    const extractKeywords = (note: string) => {
        const matches = note.matchAll(/【(.+?)】/g);
        const keywords = Array.from(matches).map(match => match[1]);
        return keywords;  // 返回数组，包含所有匹配的关键词
    }

    const dispatch = useDispatch();

    const setShapeId = (id: string, shapeProps: FrameShapeProps) => {
        dispatch(setCurrentTaskFrameIds({...currentTaskFrameIds, [id]: shapeProps}))
    }

    const setDraw = async () => {
        if (!taskResponse?.data) return;

        const imagesCount = taskResponse.data.length
        const columnCount = Math.min(imagesCount, triggerCmd === CommandType.FETCH_IMAGES ? Constant.CollectImagesColumn : Constant.GenerateImagesColumn);

        //基于发散联想的结果，搜集【蛇_鳞片】参考图
        const keyWords = extractKeywords(taskResponse.note)[0];
        
        // 使用Hook提供的方法创建瀑布流布局
        await createWaterfallLayout(
            checkedImg,
            taskResponse.data,
            temporary_url,
            {
                columnCount,
                columnGap: Constant.FrameColumnGap,
                framePadding: Constant.FramePadding,
                maxImageWidth: Constant.MaxImageWidth
            },
            keyWords,
            setShapeId,
            currentTaskFrameIds
        );
    }

    useEffect(() => {
        if (extra && extra?.checkedImgs) {
            setCheckedImg(extra?.checkedImgs)
        }else if (taskResponse?.data) {
            const checked = Object.keys(taskResponse.data).map(v => parseInt(v));
            setCheckedImg(checked)
            taskId && changeTaskProcess(taskId, {extra: { checkedImgs:checked}})
        }
    }, [taskResponse, taskId, extra]);

    const placeOrderHeight = (width?: number, height?: number) => {
        if (!width || !height) return ''
        const coefficient = 156 / width;
        return height * coefficient
    }

    return <Box className="task_manage_box">
        <Box className='flex' style={{alignItems: 'baseline'}}>
            <div style={{overflowWrap: "break-word"}}>{taskResponse?.note}</div>
            <TaskTool status={status} taskId={taskId} text={t('collect')} triggerEvent={async ()=> await setDraw()}/>
        </Box>
        {
            singleGenerate ? <Box className="task_manage_sub">
                <PaintSwiper>
                    {
                        taskResponse?.data?.map((img, index)=>
                            <img style={{width: '100%', height: "100%", objectFit: "contain"}} key={index}
                                 src={`${temporary_url}${img.lod1}`} alt={``}/>
                        )
                    }
                </PaintSwiper>
                {/* <img style={{width: '100%'}} src={`${temporary_url}${taskResponse?.data[0].url}`} alt={`蛇图片`}/>*/}
            </Box> : <Box className="task_manage_sub waterfall-grid">
                {!taskResponse?.data?.length && <span>{t('no_related_images')}</span>}
                {taskResponse?.data?.map((sub, index) => (
                    <Box key={index} className="waterfall-item">
                        <IconButton color="primary" onClick={()=>{
                            handleSetDialogInfo && handleSetDialogInfo({...sub, url: `${temporary_url}${sub.url}`})
                        }} size='small' aria-label="add to shopping cart" style={{position: 'absolute', top: 3}}>
                            <SearchIcon onClick={handleClickOpen} />
                        </IconButton>
                         <Checkbox disabled={conversionValue === ConversionType.HISTORY || status === TaskStatusType.COMPLETED} checked={checkedImg.includes(index)} onChange={(e) =>{changeProcessRes(index, e.target.checked)}} {...label} defaultChecked size='small' style={{position: "absolute", right: 0}} />
                        <img src={`${temporary_url}${sub.lod1}`} alt={``} />
                    </Box>
                ))}
            </Box>
        }
        <Box className='flex' style={{marginTop: 8}}><Handle/></Box>
    </Box>
}